export default __webpack_public_path__ + "static/img_welfare_8-56226aa4a08c0b55d464409a90e879f4.jpg";